/// <amd-module name="Test/TestPlansHubRefresh/TestCaseResultsPanel/TestCaseResultsPanelConstants" />
export const OutcomeColumn = "outcome";
export const TimeStampColumn = "timestamp";
export const ConfigurationColumn = "configuration";
export const RunByColumn = "runBy";
export const TesterColumn = "tester";
export const TestPlanColumn = "testPlanName";
export const TestSuiteColumn = "testSuiteName";
export const STATE_COMPLETED = "COMPLETED";
export const OUTCOME_UNSPECIFIED = "UNSPECIFIED";
export const OUTCOME_NONE = "NONE";
export const OUTCOME_PASSED = "PASSED";
export const OUTCOME_FAILED = "FAILED";
export const OUTCOME_INCONCLUSIVE = "INCONCLUSIVE";
export const OUTCOME_TIMEOUT = "TIMEOUT";
export const OUTCOME_ABORTED = "ABORTED";
export const OUTCOME_BLOCKED = "BLOCKED";
export const OUTCOME_NOTEXECUTED = "NOTEXECUTED";
export const OUTCOME_WARNING = "WARNING";
export const OUTCOME_ERROR = "ERROR";
export const OUTCOME_NOTAPPLICABLE = "NOTAPPLICABLE";
export const OUTCOME_PAUSED = "PAUSED";
export const OUTCOME_INPROGRESS = "INPROGRESS";
export const OUTCOME_NOTIMPACTED = "NOTIMPACTED";
export const TestRunsPageRouteId = "ms.vss-test-web.test-runs-route";
export const TestRunsPageQueryParams = "?_a=resultSummary&runId={0}&resultId={1}";
export const OPEN_RUNS_HUB = "OPEN_RUNS_HUB";
export const TestExecutionHistoryRouteId = "ms.vss-test-web.testcase-results-route";
export const queryParams_ExecutionHistory = "?testCaseId={0}&contextPointId={1}";
export const ZeroDataImagePath = "ms.vss-test-web/testplan-hub-refresh-assets/zero-data-execute-tab.png";
